module.exports = __webpack_public_path__ + "img/canada-cancer-female.001b985a.png";